import { render } from "./ClientProjectDetail.vue?vue&type=template&id=a476e7fa&scoped=true"
import script from "./ClientProjectDetail.vue?vue&type=script&lang=js"
export * from "./ClientProjectDetail.vue?vue&type=script&lang=js"

import "./ClientProjectDetail.vue?vue&type=style&index=0&id=a476e7fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a476e7fa"]])

export default __exports__